import { useRef } from "react";

export function useDebounce(callback: (...args: any[]) => void, delay: number) {
    const timeoutRef = useRef<number | undefined>();
  
    return (...args: any[]) => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = window.setTimeout(() => {
        callback(...args);
      }, delay);
    };
  }